import houseTypeMap from './houseTypeMap';

export default Object.freeze({
  [houseTypeMap.house]: 'Дом',
  [houseTypeMap.possession]: 'Владение',
  [houseTypeMap.homeOwnership]: 'Домовладение',
  [houseTypeMap.building]: 'Здание',
});
